'use strict';

var _ = require('lodash');
var SaveRuleService = function SaveRuleService(restangular, configurationService, conditionSerializer, saveStrategyService, transformerClassClosureService, transformerAllocationAvailAuthService, strategyConstants, $q, duplicateNameService, strategiesService, momentService, strategyListingService, conditionsFilter, featureToggleService) {
  var rulesAPI = restangular.one('rules');
  var rulesSearchAPI = restangular.all('rules');
  function getUserId() {
    return configurationService.getUserId();
  }
  function getCarrier() {
    return configurationService.getHostCarrier();
  }
  function retrieveRuleNames() {
    return rulesSearchAPI.get('').then(function (data) {
      return _.map(data.detailedRules, 'name');
    });
  }
  function repopulateStrategy(strategy) {
    if (strategy && strategy.groups) {
      strategiesService.repopulateStrategy(strategy);
    }
  }
  function saveRule(rule, strategy) {
    if (strategy && strategy.groups) {
      strategy = strategiesService.cleanStrategy(_.extend({}, strategy));
    }
    var DEFAULT_END_DATE = '2999-12-31';
    var isQuickRule = !_.isUndefined(strategy);
    var primaryCriteria = conditionsFilter.notEmptyConditions(rule.primaryCriteria);
    primaryCriteria = conditionsFilter.notAllOperandItemsSelected(primaryCriteria);
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var createdAt = momentService.copy(eventTimeStamp, momentService.FIELD.CREATED_AT);
    var createdDate = momentService.copy(eventTimeStamp, momentService.FIELD.CREATED_DATE);
    var lastUpdatedAt = momentService.copy(eventTimeStamp, momentService.FIELD.LAST_UPDATED_AT);
    var discontinueDate = rule.discontinueDate ? rule.discontinueDate : momentService.of(DEFAULT_END_DATE, momentService.FIELD.RULE_DISCONTINUE_DATE);
    var subject = {};
    var saveRequestParams = {
      name: rule.name,
      carrier: getCarrier(),
      notes: rule.notes,
      isQuickRule: isQuickRule,
      description: rule.description,
      status: rule.status.domain,
      category: 'TO BE DETERMINED',
      isUserOverride: false,
      isTrumpOverride: rule.isTrumpOverride,
      priority: rule.priority,
      createdBy: rule.createdBy || getUserId(),
      eventTimeStamp: rule.isEditing ? rule.eventTimeStamp.toISOString() : eventTimeStamp.toISOString(),
      technicalId: rule.technicalId,
      createdAt: createdAt.toISOString(),
      createdDate: rule.isEditing ? rule.createdDate.toISOString() : createdDate.toISOString(),
      effectiveDate: rule.effectiveDate && withTimeAtTheStartOfDay(rule.effectiveDate).toISOString(),
      discontinueDate: withTimeAtTheEndOfDay(discontinueDate).toISOString(),
      type: rule.type,
      usage: 0,
      lastUpdatedAt: lastUpdatedAt.toISOString(),
      lastUpdatedBy: getUserId(),
      scenarioName: rule.scenarioName,
      isDsl: true,
      flowType: getRuleFlowType(rule)
    };
    subject.level = rule.primaryCriteriaLevel.domain;
    subject.conditions = conditionSerializer.serialize(rule.primaryCriteriaLevel.domain, rule.type, rule.flowType, primaryCriteria);
    if (rule.ruleFormulae != null && rule.ruleFormulae.length > 0) {
      subject.formulae = rule.ruleFormulae;
    }
    saveRequestParams.subject = subject;
    var filteredLinkCriteria = conditionsFilter.notAllOperandItemsSelected(rule.linkCriteria);
    if (rule.linkCriteriaEnabled) {
      if (isEmptyLinkCriteria(filteredLinkCriteria)) {
        rule.linkCriteriaEnabled = false;
      } else {
        var linkObject = {};
        linkObject.level = rule.linkCriteriaLevel.domain;
        linkObject.conditions = conditionSerializer.serialize(rule.linkCriteriaLevel.domain, rule.type, rule.flowType, filteredLinkCriteria);
        if (rule.linkFormulae != null && rule.linkFormulae.length > 0) {
          linkObject.formulae = rule.linkFormulae;
        }
        saveRequestParams.linkObject = linkObject;
      }
    }
    if (_.isEmpty(rule.appliedStrategies)) {
      saveRequestParams.strategiesRef = [];
    } else {
      saveRequestParams.strategiesRef = _.map(rule.appliedStrategies, function (s) {
        return {
          technicalId: s.technicalId
        };
      });
    }
    if (isQuickRule) {
      var isCustomBasis = strategy.basis === 'custom';
      strategy.quickRule = true;
      strategy.name = '(QR) ' + rule.name;
      strategy.type = rule.type;
      strategy.flowType = rule.flowType;
      if (isCustomBasis && (hasLevelSecondaryCriteria(strategy) || hasActions(strategy))) {
        return saveLevelStructureQuickRule(strategy, saveRequestParams);
      } else if (!isCustomBasis) {
        return saveQuickRuleWithTemplate(strategy, saveRequestParams);
      } else {
        //saving Quick Rule without secondary criteria
        return save(saveRequestParams);
      }
    } else {
      return save(saveRequestParams);
    }
  }
  function withTimeAtTheStartOfDay(date) {
    return date.startOf('day');
  }
  function withTimeAtTheEndOfDay(date) {
    return date.endOf('day');
  }
  function isEmptyLinkCriteria(linkCriteria) {
    return !linkCriteria || !linkCriteria.length || linkCriteria.length === 1 && linkCriteria[0].isEmpty();
  }
  function hasLevelSecondaryCriteria(strategy) {
    return hasGroupSomeNotEmptySubElements(strategy, 'conditions');
  }
  function hasActions(strategy) {
    return hasGroupSomeNotEmptySubElements(strategy, 'actions');
  }
  function hasGroupSomeNotEmptySubElements(strategy, subGroupCollectionName) {
    return _.some(strategy.groups, function (group) {
      return !_.isEmpty(group[subGroupCollectionName]);
    });
  }
  function saveLevelStructureQuickRule(strategy, saveRequestParams) {
    return saveRuleWithStrategy(saveRequestParams, strategy);
  }
  function saveTemplateStructureQuickRule(strategy, saveRequestParams, templateLevel) {
    var transformService = strategy.basis === strategyConstants.ALLOCATION_AUTH_AVAIL.BASIS ? transformerAllocationAvailAuthService : transformerClassClosureService;
    var transformedPayload = transformService.transform(strategy, strategy.commonConditions);
    return saveRuleWithStrategy(saveRequestParams, transformedPayload.strategy, templateLevel, transformedPayload.commonConditions);
  }
  function saveRuleWithStrategy(ruleRequestParams, strategy, level, conditions) {
    var strategyRequestParams = saveStrategyService.getStrategySaveRequestParams(strategy, level, conditions);
    ruleRequestParams.strategies = [strategyRequestParams];
    return save(ruleRequestParams)["catch"](function (response) {
      return $q.reject(response);
    });
  }
  function saveQuickRuleWithTemplate(strategy, saveRequestParams) {
    var templateLevel = strategy.basis === strategyConstants.ALLOCATION_AUTH_AVAIL.BASIS ? strategyConstants.ALLOCATION_AUTH_AVAIL.LEVEL : strategyConstants.CLASS_CLOSURE.LEVEL;
    return saveTemplateStructureQuickRule(strategy, saveRequestParams, templateLevel);
  }
  function save(saveRequestParams) {
    return rulesAPI.customPUT(saveRequestParams);
  }
  function duplicate(rule) {
    if (rule.isQuickRule && rule.strategies) {
      return saveStrategyService.getStrategyDuplicate(rule.strategies[0]).then(function (duplicateStrategy) {
        rule.strategies[0] = duplicateStrategy;
        delete rule.strategiesRef;
      }).then(duplicateRule.bind(null, rule));
    } else {
      delete rule.strategies;
      return duplicateRule(rule);
    }
  }
  function duplicateRule(rule) {
    var duplicateRuleData = _.cloneDeep(rule);
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var lastUpdatedAt = momentService.copy(eventTimeStamp, momentService.FIELD.LAST_UPDATED_AT);
    var createdAt = momentService.copy(eventTimeStamp, momentService.FIELD.CREATED_AT);
    var createdDate = momentService.copy(eventTimeStamp, momentService.FIELD.CREATED_DATE);
    duplicateRuleData.createdBy = getUserId();
    duplicateRuleData.lastUpdatedBy = getUserId();
    duplicateRuleData.lastUpdatedAt = lastUpdatedAt.toISOString();
    duplicateRuleData.createdAt = createdAt.toISOString();
    duplicateRuleData.createdDate = createdDate.toISOString();
    duplicateRuleData.eventTimeStamp = eventTimeStamp.toISOString();
    duplicateRuleData.effectiveDate = duplicateRuleData.effectiveDate && duplicateRuleData.effectiveDate.toISOString();
    duplicateRuleData.discontinueDate = duplicateRuleData.discontinueDate ? duplicateRuleData.discontinueDate.toISOString() : '';
    delete duplicateRuleData.technicalId;
    delete duplicateRuleData.refStrategiesCount;

    // reset DRL data:
    delete duplicateRuleData.ruleDrl;
    delete duplicateRuleData.strategyDrl;
    duplicateRuleData.isDsl = true;
    return retrieveRuleNames().then(function (names) {
      duplicateRuleData.name = duplicateNameService.createNewName(rule.name, names);
      return save(duplicateRuleData);
    }).then(function () {
      return duplicateRuleData;
    });
  }
  function getRuleById(technicalId) {
    return rulesSearchAPI.get('?filter=technicalId==' + technicalId);
  }
  function updateRule(rule) {
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var lastUpdatedAt = momentService.copy(eventTimeStamp, momentService.FIELD.LAST_UPDATED_AT);
    rule.eventTimeStamp = eventTimeStamp.toISOString();
    rule.lastUpdatedAt = lastUpdatedAt.toISOString();
    rule.lastUpdatedBy = getUserId();
    return save(rule);
  }
  function getRuleFlowType(rule) {
    return featureToggleService.isEnabled('MAPPED_MODE') && rule.flowType && rule.flowType !== 'FlowType.BOTH' ? rule.flowType.replace(/FlowType./g, '') : undefined;
  }
  return {
    saveRule: saveRule,
    duplicateRule: duplicate,
    getRuleById: getRuleById,
    updateRule: updateRule,
    repopulateStrategy: repopulateStrategy
  };
};
SaveRuleService.$inject = ['Restangular', 'ConfigurationService', 'ConditionSerializerService', 'SaveStrategyService', 'ModelToPayloadTransformerService', 'ModelToPayloadTransformerServiceAAA', 'StrategyConstants', '$q', 'DuplicateNameService', 'StrategiesService', 'MomentService', 'StrategyListingService', 'CriteriaValidateAndFilterService', 'FeatureToggleService'];
module.exports = SaveRuleService;